import React from 'react';

type RaupōProps = {
    nama: number,
    viewingGroup?: boolean
}

const Raupō = ({ nama, viewingGroup }: RaupōProps) => {

    const angles: number[] = []

    for (let i = 0; i < nama; i++) {

        let angle: number | string = Math.floor(Math.random() * 10);
        const evenOdds = angle % 2;

        evenOdds ? angle = angle * -0.1 : angle = angle * 0.1;
        angles.push(angle);
    };

    let raupōStyle = 'py-8 w-screen border-t-1 bg-kaho-2 '

    viewingGroup ? raupōStyle += 'border-toto-2 inset-shadow-sm/20 inset-shadow-toto-1' : raupōStyle += 'border-raupo inset-shadow-kaho-0 inset-shadow-sm/30'

    return (
        <div id="backgroundDecoration" className="fixed top-0 -z-1 flex-col w-screen h-screen overflow-hidden opacity-60">
            {angles.map((line, index) => (<div className={raupōStyle} style={{ transform: `rotate(${line}deg)` }} key={"raupō"+index}></div>))}
        </div>
    );
};

export default Raupō

